<agpr-dialog-container
    [id]="id"
    [heading]="localizations.heading"
    styleClass="agpr-saveTopicDialog"
    (close)="cancel()"
>
    <agpr-scroll-panel>
        <div class="agpr-saveTopicDialog-content">
            <agpr-text-input
                [id]="id + '_name'"
                [label]="localizations.nameLabel"
                [placeholder]="localizations.nameHint"
                [maxLength]="64"
                [required]="true"
                [(ngModel)]="topicName"
                (ngModelChange)="validateName()"
            ></agpr-text-input>
            @if (!nameIsValid) {
                <agpr-form-message>
                    {{ 'Monitoring.duplicateTopicNameError' | localize }}
                </agpr-form-message>
            }
            @if (hasAgent) {
                <agpr-textarea-input
                    [id]="id + '_searchIntent'"
                    [label]="'SaveTopicDialog.searchIntentLabel' | localize"
                    [placeholder]="'SaveTopicDialog.searchIntentHint' | localize"
                    [maxLength]="2056"
                    [(ngModel)]="searchIntent"
                ></agpr-textarea-input>
            }
            <div class="agpr-saveTopicDialog-topicWorkflowHeading">
                {{ localizations.workflowSettingsHeading | localize }}
            </div>
            <ng-container [formGroup]="workflowSettingsForm">
                <agpr-topic-workflow-settings
                    formGroupName="topicWorkFlowSettings"
                    [showErrors]="!tagIsValid"
                ></agpr-topic-workflow-settings>
            </ng-container>
            <div class="agpr-saveTopicDialog-topicWorkflowHeading">
                {{ 'SaveTopicDialog.saveAsNew.organization' | localize }}
            </div>
            <agpr-checkbox
                [id]="'saveTopicDialog_addToGroup'"
                class="agpr-saveTopicDialog-addToGroup"
                [(ngModel)]="addToGroup"
                [binary]="true"
                label="Common.dialog.newResource.addToGroup.label"
                (onChange)="onAddToGroupChange()"
            ></agpr-checkbox>
            <div class="agpr-saveTopicDialog-groupSelection">
                <agpr-autocomplete
                    [id]="'saveNewResourceDialog_groupInput'"
                    [dropdown]="true"
                    placeholder="Common.dialog.newResource.group.placeholder"
                    labelField="name"
                    [suggestions]="groupOptions"
                    [(ngModel)]="selectedGroup"
                    [clearOnBlur]="false"
                    [customOptions]="autocompleteCustomOptions"
                    [disabled]="!addToGroup"
                >
                </agpr-autocomplete>
            </div>
        </div>
    </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            (click)="cancel()"
            label="cancel"
            class="ui-button-secondary"
            [id]="id + '_cancelButton'"
            [disabled]="showLoading"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [style]="buttonTypes.primary"
            (click)="save()"
            [id]="id + '_SaveButton'"
            label="save"
            [disabled]="!_search || submitted"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
